import { useContext, useEffect, useState } from 'react';
import {
  CollapseButton,
  LeftMenuContainer,
  LeftMenuHeader,
  LeftMenuSkeleton,
  MenuItemSkeleton,
} from './styles';
import { List, Question } from '@phosphor-icons/react';
import { LeftMenuGroup, MenuGroup } from './LeftMenuGroup';
import { AppsMenuContext } from '../../contexts/AppsMenuContext';
import { SettingsMenuContext } from '../../contexts/SettingsMenuContext';
import { useTranslation } from 'react-i18next';

interface LeftMenuProps {
  type: 'apps' | 'settings';
  onLinkClick: (key: string) => void;
  isTrial: boolean;
}

export const LeftMenu = ({ type, onLinkClick, isTrial }: LeftMenuProps) => {
  const [title, setTitle] = useState('Menu');
  const [isOpen, setIsOpen] = useState(true);
  const [groups, setGroups] = useState<MenuGroup[]>();

  const { t } = useTranslation('leftmenu');

  const { groups: appsGroups } = useContext(AppsMenuContext);
  const { groups: settingGroups } = useContext(SettingsMenuContext);

  useEffect(() => {
    switch (type) {
      case 'apps':
        setTitle(t('APPS_MENU_TITLE'));
        setGroups(appsGroups);
        break;
      case 'settings':
        setTitle(t('SETTINGS_MENU_TITLE'));
        setGroups(settingGroups);
        break;
      default:
        break;
    }
  }, [appsGroups, settingGroups, t, type]);

  return (
    <LeftMenuContainer isOpen={isOpen} isTrial={isTrial}>
      <LeftMenuHeader isOpen={isOpen}>
        {isOpen && <h1>{title}</h1>}
        <CollapseButton isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
          <List />
        </CollapseButton>
      </LeftMenuHeader>

      {
        <div className="sidebarContentWrapper">
          <div className="menuItems">
            <nav>
              <ul>
                {groups && groups.length > 0 ? (
                  <>
                    {groups
                      .sort((a, b) => {
                        if (a.title === t('MENU_GROUP_MANAGE_SUBSCRIPTIONS')) {
                          return -1;
                        } else if (
                          b.title === t('MENU_GROUP_MANAGE_SUBSCRIPTIONS')
                        ) {
                          return 1;
                        } else {
                          return a.title.localeCompare(b.title);
                        }
                      })
                      .map((group) => (
                        <LeftMenuGroup
                          key={'left-menu-group-' + group.title}
                          group={group}
                          isMenuOpen={isOpen}
                          onLinkClick={onLinkClick}
                          toggleMenu={() => setIsOpen(!isOpen)}
                        />
                      ))}
                    {type === 'settings' && (
                      <li>
                        <button
                          onClick={() => onLinkClick('help')}
                          className="help"
                        >
                          <Question size={32} />
                          <span>{t('MENU_LINK_HELP_AND_FEEDBACK')}</span>
                        </button>
                      </li>
                    )}
                  </>
                ) : (
                  <LeftMenuSkeleton>
                    <MenuItemSkeleton />
                    <MenuItemSkeleton />
                  </LeftMenuSkeleton>
                )}
              </ul>
            </nav>
          </div>
        </div>
      }
    </LeftMenuContainer>
  );
};
